import { initialDaFeedbackState } from "store/initialStates";
import { ReducersInterfaceAction } from "types/Reducers";
import { DaFeedbackState } from "types/DaFeedback";
import { DaFeedbackConstants } from "constants/constants";

export const daFeedbackReducer = (
  state = initialDaFeedbackState,
  action: ReducersInterfaceAction,
): DaFeedbackState => {
  switch (action.type) {
    case DaFeedbackConstants.DA_FEEDBACK_GET_LIST_SUCCESS:
      return {
        ...state,
        loadingData: false,
        feedbackListCount: action.payload.length,
        dataList: action.payload,
      };
    case DaFeedbackConstants.DA_FEEDBACK_GET_REPORT_SUCCESS:
      return {
        ...state,
        loadingData: false,
        currentReport: action.payload,
      };
    case DaFeedbackConstants.DA_FEEDBACK_UPDATE_REPORT_SUCCESS:
      return {
        ...state,
        loadingData: false,
        currentReport: action.payload,
      };
    case DaFeedbackConstants.DA_FEEDBACK_LOADING:
      return {
        ...state,
        loadingData: true,
      };
    case DaFeedbackConstants.DA_FEEDBACK_ERROR:
      return {
        ...state,
        loadingData: false,
      };
    case DaFeedbackConstants.DA_FEEDBACK_CHANGE_FILTERS:
      return {
        ...state,
        feedbackFilters: action.payload,
      };
    default:
      return state;
  }
};
